import api from './axios'

export default {
  getCourses: (params, config = {}) =>
    api.get('/courses', { params, ...config }),
  getCourse: (params, config = {}) => api.get('/course', { params, ...config }),
  delCourse: (data, config = {}) => api.delete('/course', { data, ...config }),
  createCourse: (data, config) => api.post('/course', data, config),
  updateCourse: (data, config) => api.patch('/course', data, config),
  archiveCourse: (data, config) => api.put('/course', data, config),
  applyCourse: (data, config) => api.post('/course/member', data, config),
  acceptApply: (data, config) => api.patch('/course/member', data, config),

  getCoursewareFSAuth: params =>
    api.post('/course/courseware/auth', undefined, { params }),
  getSubmitWorkFSAuth: data => api.post('/course/submission/auth', data),

  getMembers: (params, config = {}) =>
    api.get('/course/members', { params, ...config }),
  delMember: (data, config = {}) =>
    api.delete('/course/member', { data, ...config }),

  createWork: (data, config) => api.post('/course/exercise', data, config),
  getWorks: (params, config = {}) =>
    api.get('/course/exercises', { params, ...config }),
  getWork: (params, config = {}) =>
    api.get('/course/exercise', { params, ...config }),
  updateWork: (data, config) => api.patch('/course/exercise', data, config),
  delWork: (data, config = {}) =>
    api.delete('/course/exercise', { data, ...config }),
  submitWork: (data, config) => api.post('/course/submission', data, config),

  getSubmissions: (params, config = {}) =>
    api.get('/course/submissions', { params, ...config }),
  getSubmission: (params, config = {}) =>
    api.get('/course/submission', { params, ...config }),
  gradeSubmission: (data, config) =>
    api.patch('/course/submission/grade', data, config),
  getExerciseAttachmentAuth: (data, config) =>
    api.post('/course/exercise_attachment/auth', data, config),

  getCourseOutline: (params, config) =>
    api.get('/course/outline', { params, ...config }),
  updateCourseOutline: (data, config) =>
    api.patch('/course/outline', data, config),

  createQuickComment: (data, config) =>
    api.post('/course/quick_comment', data, config),
  getQuickComments: (params, config = {}) =>
    api.get('/course/quick_comments', { params, ...config }),
  delQuickComment: (data, config = {}) =>
    api.delete('/course/quick_comment', { data, ...config }),
  setRole: (data, config = {}) =>
    api.patch('/course/member_role', data, config),
  getSignInList: (params, config = {}) =>
    api.get('/courses/sign_ins', { params, ...config }),
  createSignIn: (data, config = {}) =>
    api.post('/courses/sign_in', data, config),
  getSignInToken: (params, config = {}) =>
    api.get('/courses/sign_in', { params, ...config }),
  stopSignIn: (data, config) => api.patch('/courses/sign_in', data, config),
  deleteSignIn: (params, config = {}) =>
    api.delete('/courses/sign_in', { params, ...config }),
  exportSignIn: (params, config = {}) =>
    api.get('/courses/sign_in/export', { params, ...config }),
  getSignInDetail: (params, config = {}) =>
    api.get('/courses/sign_in/members', { params, ...config }),
  updateSignInMemberStatus: (data, config) =>
    api.patch('/courses/sign_in/member', data, config),

  getInviteCode: (params, config = {}) =>
    api.get('/course/invitation', { params, ...config })
}
